export class HaveNotQueryOAUTHError extends Error {
  constructor(query: string[]) {
    super(`Query параметры не были переданы на страницу. Ожидался один из: ${query}`)
  }
}